import classnames from "classnames";

import { TextField, TextFieldProps } from "@material-ui/core";

import { useFormInputStyles } from "src/styles/forms";

export default function FormTextField(props: TextFieldProps): JSX.Element {
  const formInputStyles = useFormInputStyles();

  return (
    // @ts-ignore disableUnderline isn't technically allowed if you pass variant="outlined"
    <TextField
      classes={
        props.error
          ? {
              root: classnames(
                formInputStyles.textFieldRootWithError,
                props.classes?.["root"]
              )
            }
          : {
              root: classnames(
                formInputStyles.textFieldRootWithoutError,
                props.classes?.["root"]
              )
            }
      }
      {...(props as TextFieldProps)}
      InputLabelProps={{
        shrink: true,
        classes: { root: formInputStyles.inputLabel },
        ...(props.InputLabelProps || {})
      }}
      InputProps={{
        disableUnderline: true,
        classes: {
          root: formInputStyles.textFieldInputRoot,
          input: formInputStyles.input
        },
        ...(props.InputProps || {})
      }}
    />
  );
}
